// extracted by mini-css-extract-plugin
var _1 = "SharingDropdownAccessList-module__row--b07vG";
export { _1 as "row" }
